<template>
    <section>
        <div class="verifier-admonition">
            <lightbulbIcon class="verifier-admonition__icon" />

            <div class="verifier-admonition__right">
                <h2 class="verifier-admonition__title">
                    {{ $t('address.contract.tg_wallet.title') }}
                </h2>

                <div class="verifier-admonition__text">
                    {{ $t('address.contract.tg_wallet.text') }}
                </div>
            </div>
        </div>

        <div class="tx-history-wrap desktop-table">
            <table class="ui-table">
                <tbody>
                    <tr>
                        <td class="tg-wallet-state__name">{{ $t('address.contract.tg_wallet.public_key') }}</td>
                        <td>
                            <ui-copy-button class="tg-wallet-state__key"
                                v-bind:successMessage="$t('address.contract.tg_wallet.public_key_copy_success')"
                                v-bind:copy="state.publicKey">
                                {{ state.publicKey }}
                            </ui-copy-button>
                        </td>
                    </tr>
                    <tr>
                        <td class="tg-wallet-state__name">{{ $t('address.contract.tg_wallet.seqno') }}</td>
                        <td>{{ state.seqno }}</td>
                    </tr>
                    <tr>
                        <td class="tg-wallet-state__name">{{ $t('address.contract.tg_wallet.subwallet_id') }}</td>
                        <td>{{ state.subwalletId }}</td>
                    </tr>
                    <tr>
                        <td class="tg-wallet-state__name">{{ $t('address.contract.tg_wallet.revision') }}</td>
                        <td>{{ state.revision }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </section>
</template>

<script>
import lightbulbIcon from '@img/icons/lucide/lightbulb.svg?vue';

export default {
    props: {
        state: {
            type: Object,
            required: true,
        },
    },

    components: {
        lightbulbIcon,
    },
};
</script>

<style lang="scss">
.tg-wallet-state {
    &__name {
        color: var(--body-muted-text-color);
        white-space: nowrap;
        width: 1%;
        padding-right: 32px;
    }

    &__key {
        font-family: monospace;
        word-break: break-all;
    }
}
</style>
